import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import {
  baseUrl,
  baseUrlApi,
  checkApi,
  liveMatchesApi,
  recentMatchesApi,
  weeklyMatchesApi,
} from "../api/api";
import moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import MatchLayout from "../components/MatchLayout";
import classes from "../css/HomePage.module.css";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import SHA256 from "crypto-js/sha256";
import {  loginApi, signupApi } from "../api/api";
import { setUser } from "../slices/userSlice";


const HomePage = () => {
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);
  const [matches, setMatches] = useState([]);
  const [recentMatches, setRecentMatches] = useState([]);
  const [liveMatches, setLiveMatches] = useState([]);
  const [todayMatches, setTodayMatches] = useState([]);
  const [todayMatchesResults, setTodayMatchesResults] = useState([]);
  const [weeklyMatches, setWeeklyMatches] = useState([]);
  const { lang } = useSelector((state) => state.langSlice);
  const params = new URLSearchParams(window.location.search);
  const msisdn = params.get("msisdn");
const dispatch = useDispatch();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  function encrypt(value, length = 8) {
    const hash = SHA256(String(value)).toString(); // hex
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  
    let result = "";
    for (let i = 0; i < length; i++) {
      const hexPair = hash.substr(i * 2, 2);
      const num = parseInt(hexPair, 16);
      result += letters[num % letters.length];
    }
  
    return result;
  }

  const navigate = useNavigate();

const checkUser = async () => {
  // const msisdn = localStorage.getItem("msisdn")

  const params = new URLSearchParams(window.location.search);
  const msisdn = params.get("msisdn") || localStorage.getItem("msisdn");

  

  if (!msisdn) {
    toast.error("User is not subscribed");
    setRedirecting(true); // Show only loader
    setTimeout(() => {
      navigate("/subscribe");
              // window.location.href = 'https://vd-kickwin.gameit.in/subscribe'
    }, 3000);
    return;
  }

  try {
    const payload = { msisdn: msisdn.trim() };
    const response = await axios.post(`${baseUrlApi}${checkApi}`, payload);
    const { accessGranted } = await response.data;

    if (!accessGranted) {
      setRedirecting(true);
      setTimeout(() => {
        navigate("/subscribe");
        // window.location.href = 'https://vd-kickwin.gameit.in/subscribe'
      }, 3000);
    }
    else{
      localStorage.setItem('msisdn',msisdn)
    }
  } catch (error) {
    // toast.error("Error checking subscription.");
    setRedirecting(true);
    setTimeout(() => {
      navigate("/subscribe");
              // window.location.href = 'https://vd-kickwin.gameit.in/subscribe'
              navigate('/subscribe')

    }, 3000);
  }
};

useEffect(()=>{
  checkUser()
},[])


  const fetchDataFromBackend = async (loader) => {
    try {
      if (loader?.loading) {
        setLoading(true);
      }
      const res = await axios.get(`${baseUrl}${liveMatchesApi}`, {
        timezone: moment.tz.guess(),
        date: moment().tz(moment.tz.guess()).format("YYYY-MM-DD"),
      });

      console.log(res, "res");

      setMatches(res?.data?.response?.data);

      // TODAY MATCHES PREMIERE LEAGUE
      setTodayMatches(
        res?.data?.response?.data.filter(
          (data) =>
            data.matchStatus != "Match Finished" && data.matchTime == null
        )
      );

      // LIVE MATCHES PREMIERE LEAGUE
      setLiveMatches(
        res?.data?.response?.data.filter(
          (data) =>
            data.matchTime != null && data.matchStatus != "Match Finished"
        )
      );

      // TODAY MATCHES RESULTS PREMIERE LEAGUE
      setTodayMatchesResults(
        res?.data?.response?.data.filter(
          (data) => data.matchStatus == "Match Finished"
        )
      );

      console.log(res, "response....");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // toast.error(
      //   error?.response?.data?.message ||
      //     error?.data?.message ||
      //     error?.message ||
      //     error
      // );
    }
  };

  console.log(liveMatches, "livematches");
  console.log(matches, "m");

  const fetchRecentMatchesFromBackend = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}${recentMatchesApi}`, {
        timezone: moment.tz.guess(),
      });
      console.log(res.data.response, "resssssssss recent");
      setRecentMatches(
        res?.data?.response?.filter(
          (data) => data.matchStatus == "Match Finished"
        )
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error)
      // toast.error(
      //   error?.data || error?.data?.message || "Something Went Wrong!"
      // );
      console.log(error, "error");
    }
  };

  const fetchWeeklyMatchesFromBackend = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}${weeklyMatchesApi}`, {
        timezone: moment.tz.guess(),
      });
      console.log(res.data.response, "response weekly matches");
      setWeeklyMatches(
        res?.data?.response?.filter((data) => data.matchTime == null)
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error)
      // toast.error(
      //   error?.data || error?.data?.message || "Something Went Wrong!"
      // );
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchDataFromBackend({ loading: true });
    fetchRecentMatchesFromBackend();
    fetchWeeklyMatchesFromBackend();
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        fetchDataFromBackend({ loading: false });
      }
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);






  const autoSubmit = async (msisdn, pwd) => {
    console.log('auto submit called')
const number = encrypt(msisdn);
console.log(number)



  try {
    setLoading(true);
    const data = {
      name: "Kickwin User", // or userName if you prefer
      password: pwd,
      number: number.slice(0,7),
    };
    const response = await axios.post(`${baseUrl}${signupApi}`, data);
    dispatch(setUser(response?.data));
    
    setMobile("");
    setPassword("");
    setLoading(false);
  } catch (error) {
    console.log(error)

    if(error.response.status == 400){
      // navigate('/login')


      autoLogin(msisdn)






    }
    else{
    //   toast.error(
    //   error?.response?.data?.message ||
    //     error?.data?.message ||
    //     error?.message ||
    //     error
    // );
    }


    setLoading(false);
  }
};




const autoLogin = async (msisdn) => {


    const number = await encrypt(msisdn);
console.log(number.slice(0,7))

    try {
      setLoading(true);
      const data = { number: number.slice(0,7), password: msisdn };
      const res = await axios.post(`${baseUrl}${loginApi}`, data);

      dispatch(setUser(res?.data));
      // toast.success(
      //   lang === "english"
      //     ? "Logged In Automatically!"
      //     : lang === "spanish"
      //     ? "¡Inicio de sesión automático!"
      //     : lang === "french"
      //     ? "Connexion automatique réussie!"
      //     : lang === "arabic"
      //     ? "تم تسجيل الدخول تلقائيًا!"
      //     : "Logged In Automatically!"
      // );

    
    } catch (error) {
      setLoading(false);
      // toast.error(
      //   error?.response?.data?.message ||
      //   error?.data?.message ||
      //   error?.message ||
      //   "Login Failed"
      // );
      console.log(error, "autoLogin error");
    } finally {
      setLoading(false);
    }
  };



 useEffect(() => {
  const number = localStorage.getItem("msisdn") || msisdn ;
  const msisdnPassword = localStorage.getItem("msisdn");

  if (number) {
    console.log('number found')
    setLoading(true)
    setMobile(number);
    setPassword(msisdnPassword || number); // fallback to msisdn if password isn't stored
    // setUserName("Kickwin User"); // or use any default name

    // Delay submission slightly to ensure state is updated
    setTimeout(() => {

      autoSubmit(number, msisdnPassword || number);
    }, 500);
  }
}, []);






  console.log(todayMatches, "tm");
  return (
    <Layout active={1}>
      <Drawer active={1} />
      {redirecting ? (
  <div className="min-h-screen flex items-center justify-center">
    <Loader />
  </div>
) : loading ? (
  <Loading />
) : (
        <>
          <div className={classes.matches_container}>
            <div className={classes.heading_container}>
              <h1 className={classes.heading}>
                {lang == "english"
                  ? "Live Matches"
                  : lang == "spanish"
                  ? "Partidos en vivo"
                  : lang == "french"
                  ? "Matchs en direct"
                  : lang == "arabic"
                  ? "المباريات الحية"
                  : "Live Matches"}
              </h1>
            </div>
            {liveMatches?.length > 0 ? (
              liveMatches?.map((match, index) => {
                return <MatchLayout match={match} key={index} />;
              })
            ) : (
              <div className={classes.message_box}>
                <p className={classes.message}>
                  {lang == "english"
                    ? "There are no live matches currently.."
                    : lang == "spanish"
                    ? "No hay partidos en vivo actualmente."
                    : lang == "french"
                    ? "Il n'y a pas de matchs en direct actuellement."
                    : lang == "arabic"
                    ? "لا توجد مباريات مباشرة حاليا.."
                    : "There are no live matches currently.."}
                </p>
              </div>
            )}
            {todayMatches.length > 0 && (
              <>
                <div className={classes.heading_container}>
                  <h1 className={classes.heading}>
                    {lang == "english"
                      ? "Upcoming Matches Today"
                      : lang == "spanish"
                      ? "Próximos partidos de hoy"
                      : lang == "french"
                      ? "Matchs à venir aujourd'hui"
                      : lang == "arabic"
                      ? "المباريات القادمة اليوم"
                      : "Upcoming Matches Today"}
                  </h1>
                </div>

                {todayMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
            {todayMatchesResults.length > 0 && (
              <>
                <div className={classes.heading_container}>
                  <h1 className={classes.heading}>
                    {lang == "english"
                      ? "Today Matches Results"
                      : lang == "spanish"
                      ? "Resultados de los partidos de hoy"
                      : lang == "french"
                      ? "Résultats des matchs d'aujourd'hui"
                      : lang == "arabic"
                      ? "نتائج مباريات اليوم"
                      : "Today Matches Results"}
                  </h1>
                </div>
                {todayMatchesResults?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}

            {recentMatches?.length > 0 && (
              <>
                <div className={classes.heading_container}>
                  <h1 className={classes.heading}>
                    {lang == "english"
                      ? "Recent Week Matches"
                      : lang == "spanish"
                      ? "Partidos de la semana reciente"
                      : lang == "french"
                      ? "Matchs de la semaine récente"
                      : lang == "arabic"
                      ? "مباريات الأسبوع الأخيرة"
                      : "Recent Week Matches"}
                  </h1>
                </div>
                {recentMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}

            {weeklyMatches?.length > 0 && (
              <>
                <div className={classes.heading_container}>
                  <h1 className={classes.heading}>
                    {lang == "english"
                      ? "Upcoming Week Matches"
                      : lang == "spanish"
                      ? "Partidos de la próxima semana"
                      : lang == "french"
                      ? "Matchs de la semaine à venir"
                      : lang == "arabic"
                      ? "مباريات الاسبوع القادم"
                      : "Upcoming Week Matches"}
                  </h1>
                </div>
                {weeklyMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
          </div>
        </>
      )}
    </Layout>
  );
};

export default HomePage;
































































